// extracted by mini-css-extract-plugin
export default {"shortcuts":"shortcuts_shortcuts"};